import React, { useEffect, useState } from "react";
import "./index.scss";
import { home, orders, paymentSummary } from "../../utils/router/constant";
import Button from "../common/button";
import { useLocation, useNavigate } from "react-router-dom";
import { FailureLogo, FailureLogoSM } from "../../assets/images/svg/svg";
import MainLayout from "../../layout/mainLayout";
import {
  formatDate,
  formatDateTime,
  formatPaymentMode,
  getParamsFromURL,
  setParamsInURL,
} from "../../utils/helper";
import { useSelector } from "react-redux";
import { readData } from "../../service/order/orderService";
import { Col, Container, Row } from "react-bootstrap";

const Failed = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [orderId, setOrderId] = useState(null);
  const [entityid, setEntityId] = useState(null);
  const detailsData = useSelector(
    (state) => state.orders.selectedOrder.detailsData
  );

  // Set when /payment-processing hands us the polled PaymentData directly,
  // instead of the legacy encrypted `code` param.
  const routeState = location.state;

  useEffect(() => {
    if (routeState) return;

    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          setOrderId(params["orderId"]);
          setEntityId(params["entityid"]);
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location, routeState]);
  useEffect(() => {
    if (orderId) {
      readData(orderId, "ODR");
    }
  }, [orderId]);

  // Without a PspOrder entity id there is no payment summary to retry from.
  const handleTryAgain = async () => {
    if (!orderId) {
      navigate(orders);
      return;
    }

    let paramObject = {
      orderId: orderId,
    };
    const params = await setParamsInURL(location, paramObject);
    navigate(`${paymentSummary}?${params}`);
  };

  const handleCancel = async () => {
    if (!orderId) {
      navigate(orders);
      return;
    }

    let paramObject = {
      orderId: orderId,
    };
    const params = await setParamsInURL(location, paramObject);
    if (detailsData?.payment_data?.return_url) {
      window.location.href = `${detailsData?.payment_data?.return_url}?${params}`;
    } else {
      navigate(`${paymentSummary}?${params}`);
    }
  };

  const parsedResponse = JSON.parse(
    detailsData?.payment_data?.payment_response || "{}"
  );

  const paymentTime = parsedResponse?.data?.payment?.payment_time ?? 
                      parsedResponse?.payment_time ?? 
                      parsedResponse?.payment_completion_time ??
                      detailsData?.payment_data?.payment_date;

  const paymentResponse = {
    cf_payment_id: parsedResponse?.data?.payment?.cf_payment_id ?? 
                   parsedResponse?.cf_payment_id ?? 
                   detailsData?.payment_data?.txn_id,
    order_id: parsedResponse?.data?.order?.order_id ?? 
              parsedResponse?.order_id ?? 
              detailsData?.payment_data?.order_id,
    payment_amount: parsedResponse?.data?.payment?.payment_amount ?? 
                    parsedResponse?.payment_amount ?? 
                    detailsData?.payment_data?.amount,
    payment_group: parsedResponse?.data?.payment?.payment_group ?? 
                   parsedResponse?.payment_group ?? 
                   detailsData?.payment_data?.mode,
    payment_time: paymentTime,
    payment_status: parsedResponse?.data?.payment?.payment_status ?? 
                    parsedResponse?.payment_status ?? 
                    detailsData?.payment_data?.payment_status,
    bank_reference: parsedResponse?.data?.payment?.bank_reference ?? 
                    parsedResponse?.bank_reference ?? 
                    detailsData?.payment_data?.bank_rrn,
    error_details: parsedResponse?.error_details ?? {
      error_code: detailsData?.payment_data?.error_code,
      error_description: detailsData?.payment_data?.error_message,
    },
  };

  // Arriving from /payment-processing there is no `code` param and no order in
  // the store, so render from the PaymentData the status poll returned.
  const payment = routeState
    ? {
        cf_payment_id: routeState.txnId,
        order_id: routeState.orderId,
        payment_amount: routeState.amount,
        payment_group: routeState.mode,
        payment_time: routeState.paymentDate,
        payment_status: routeState.paymentStatus,
        bank_reference: routeState.bankRrn,
        error_details: {
          error_code: routeState.errorCode,
          error_description: routeState.errorMessage,
        },
      }
    : paymentResponse;

  const renderInfoBlock = (label, value) => (
    <div className="info-block">
      <div className="label">{label}</div>
      <div className="value">{value || "N/A"}</div>
    </div>
  );

  return (
    <div className="status-layout-container">
      <MainLayout>
        <div className="status--container">
          <div className="status--main">
            {/* <div className="status--image failure--bg">
              <FailureLogo />
            </div> */}
            <FailureLogoSM />
            <div className="status--content">
              <h1 className="status--title failure--title">Oops!</h1>
              <h4 className="status--subtitle">
                Order ID: {detailsData.code || payment.order_id}
              </h4>
              <h4 className="status--subtitle">Sorry! Payment Failed!</h4>
            </div>
            <div className="payment-info-container mt-4">
              {renderInfoBlock("Transaction ID", payment.cf_payment_id)}
              {renderInfoBlock("Order ID", payment.order_id)}
              {renderInfoBlock(
                "Amount",
                payment.payment_amount != null
                  ? `₹${payment.payment_amount}`
                  : null
              )}
              {renderInfoBlock("Payment Mode", formatPaymentMode(payment.payment_group))}
              {renderInfoBlock("Bank RRN", payment.bank_reference)}
              {renderInfoBlock("Date", formatDate(payment.payment_time))}
              {renderInfoBlock("Status", payment.payment_status)}
              {renderInfoBlock("Error Code", payment.error_details?.error_code)}
              {renderInfoBlock(
                "Error Message",
                payment.error_details?.error_description
              )}
            </div>

            <div className="status--footer">
              <Button
                type="button"
                variant="primary"
                label="Try Again"
                className={"btn-primary-width"}
                onClick={() => handleTryAgain()}
              />
              <Button
                type="button"
                variant="secondary"
                label="Pay Later"
                className={"btn-primary-width"}
                onClick={() => handleCancel()}
              />
            </div>
          </div>
        </div>
      </MainLayout>
    </div>
  );
};

export default Failed;
